export enum FocusableElementTags {
  BUTTON = "BUTTON",
  INPUT = "INPUT",
  TEXTAREA = "TEXTAREA",
  SELECT = "SELECT",
}
